import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocationObject } from '@tradecafe/types/core';
import { LocationSelectFormComponent, LocationSelectFormData } from './location-select-form.component';

@Injectable({ providedIn: 'root' })
export class LocationSelectFormService {
  private dialog = inject(MatDialog)


  /**
   * Opens the location select dialog
   * @param locations Array of location IDs to display
   * @param options Dialog options (title, actionTitle, multiple)
   * @returns Promise that resolves with selected location(s) or undefined if cancelled
   */
  async open(
    locations: string[],
    options?: {
      title?: string;
      actionTitle?: string;
      multiple?: boolean;
    }
  ): Promise<LocationObject | string | string[] | undefined> {
    const dialogRef = this.dialog.open<LocationSelectFormComponent, LocationSelectFormData>(
      LocationSelectFormComponent,
      {
        width: '500px',
        data: {
          locations,
          options: {
            title: options?.title || 'Select Address',
            actionTitle: options?.actionTitle || 'Update',
            multiple: options?.multiple || false
          }
        }
      }
    );

    return dialogRef.afterClosed().toPromise();
  }
}